import React, { useCallback } from 'react';
import { connect } from 'react-redux';

import IMG_LOGO_FB from 'assets/images/FB-logo.svg';
import IMG_SCREENS from 'assets/images/fb-slick-ins.png';
import IMG_LOGO_IG from 'assets/images/insta.jpeg';
import IMG_LOGO_SLICK from 'assets/images/modals/Slick-logo-purple.svg';
import SLICK from 'config/slick.singleton';
import { useTranslation } from 'providers/GILT.provider';
import fromAnyToString from 'utils/converters/fromAnyToString';
import { fromPropsToQuery } from 'utils/converters/props/path.util';
import { modifyUrl } from 'utils/links/modify.util';
import logger from 'utils/logger.util';

const L = logger('Landing');

const USE_URL_1 = false;
const USE_URL_2 = true;

// SEE: https://developers.facebook.com/docs/facebook-business-extension/fbe/get-started/business-apps
// eslint-disable-next-line max-len
const RE_VALID_REDIRECT_ORIGIN = /https?:\/\/(www\.|m\.|l\.|web\.|business\.)?(\d{4,5}\.od\.)?(business\.)?(facebook|instagram|whatsapp)\.com(\/.*)?/;

const Landing = (props) => {
  const { currentSalon, redirectUri: fromStore } = props;
  const { redirect_uri: fromParams } = fromPropsToQuery(props);

  const { t } = useTranslation();

  const tiny = currentSalon.group_ncob_tiny_url ? currentSalon.group_ncob_tiny_url : currentSalon.ncob_tiny_url;

  const urlFb = modifyUrl({ url: tiny, addParams: { utm: 'facebook' } });
  const urlIg = modifyUrl({ url: tiny, addParams: { utm: 'instagram' } });

  const extras = {
    setup: {
      external_business_id: currentSalon.id,
      timezone: 'Europe/London',
      currency: 'GBP',
      business_vertical: 'APPOINTMENTS',
    },
    business_config: {
      business: { name: currentSalon.name },
      page_cta: {
        enabled: true,
        cta_button_text: 'Book Now',
        cta_button_url: urlFb,
        below_button_text: 'Powered by Slick',
      },
      ig_cta: { enabled: true, cta_button_text: 'Book Now', cta_button_url: urlIg },
      messenger_menu: { enabled: true, cta_button_text: 'Book Now', cta_button_url: urlFb },
    },
    repeat: false,
  };

  const extras1 = JSON.stringify(extras).replace(/&/g, 'amp;');
  const extras2 = JSON.stringify(extras);

  const handleRedirect = useCallback(() => {
    const base = fromAnyToString(fromParams || fromStore);

    if (RE_VALID_REDIRECT_ORIGIN.test(base)) {
      // TODO: maybe only set it if it's from facebook or instagram or whatsapp
      L.info('handleRedirect()', 'Valid redirect URL origin:', base, { fromStore, fromParams });
    } else {
      L.error('handleRedirect()', 'Invalid redirect URL origin:', base, { fromStore, fromParams });
      return;
    }

    const url1 = `${base}&extras=${extras1}`;
    const url2 = modifyUrl({ url: base, addParams: { extras: extras2 } });

    L.info('handleRedirect()', { 'url1 === url2': url1 === url2, url1, url2, base, fromStore, fromParams });

    if (SLICK.flag?.noFbRedirect) {
      L.info('handleRedirect()', 'Aborting redirect due to SLICK.flag.noFbRedirect:', SLICK.flag?.noFbRedirect);
      return;
    }

    if (USE_URL_1) {
      L.info('handleRedirect()', 'Redirecting to url1:', url1);
      window.location.replace(url1);
    }

    if (USE_URL_2) {
      L.info('handleRedirect()', 'Redirecting to url2:', url2);
      window.location.replace(url2);
    }
  }, [fromParams, fromStore, extras1, extras2]);

  L.info('()', { 'extras1 === extras2': extras1 === extras2, extras, extras1, extras2, fromStore, fromParams });

  return (
    <div data-bem="Landing" style={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
      <div
        data-bem="Landing__logos"
        style={{
          width: '240px',
          display: 'flex',
          justifyContent: 'space-between',
          alignSelf: 'center',
          alignItems: 'center',
          marginTop: '45px',
        }}
      >
        <img src={IMG_LOGO_SLICK} alt="Slick logo" width="60px" height="60px" />
        <img src={IMG_LOGO_FB} alt="fb logo" width="48px" height="48px" />
        <img src={IMG_LOGO_IG} alt="inst logo" width="48px" height="48px" />
      </div>
      <div
        data-bem="Landing__prompt"
        style={{
          fontSize: '24px',
          color: '#821bb8',
          fontFamily: 'ProximaNova-sb',
          width: '50%',
          alignSelf: 'center',
          marginTop: '20px',
          marginBottom: '20px',
          textAlign: 'center',
        }}
      >
        <p style={{ margin: '0' }}>{t('landing.title')}</p>
        <br />
        <p style={{ lineHeight: '27px', margin: '0 auto', maxWidth: '460px' }}>{t('landing.subtitle')}</p>
      </div>
      <button data-bem="Landing__complete" className="btn btn-violet btn-shadow" onClick={handleRedirect} style={{ width: '240px', marginTop: '15px', alignSelf: 'center' }}>
        {t('landing.completeButton')}
      </button>
      <div data-bem="Landing__screens" style={{ width: '60%', display: 'flex', justifyContent: 'center', alignSelf: 'center', margin: '30px' }}>
        <img src={IMG_SCREENS} alt="Connecting your Slick account" width="490" height="auto" />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentSalon: state.currentSalon,
  redirectUri: state.salon.userPermission.redirectUri,
});

const LandingHoc = connect(mapStateToProps)(Landing);

export default LandingHoc;
